import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { encoder, concat, uint32be, lengthAndInput, concatKdf } from '../lib/buffer_utils.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';
export function deriveKey(_x, _x2, _x3, _x4) {
  return _deriveKey.apply(this, arguments);
}

function _deriveKey() {
  _deriveKey = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(publicKey, privateKey, algorithm, keyLength) {
    var apu,
        apv,
        value,
        length,
        sharedSecret,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apu = _args.length > 4 && _args[4] !== undefined ? _args[4] : new Uint8Array(0);
            apv = _args.length > 5 && _args[5] !== undefined ? _args[5] : new Uint8Array(0);

            if (isCryptoKey(publicKey)) {
              _context.next = 4;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [publicKey].concat(_toConsumableArray(types))));

          case 4:
            checkEncCryptoKey(publicKey, 'ECDH');

            if (isCryptoKey(privateKey)) {
              _context.next = 7;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [privateKey].concat(_toConsumableArray(types))));

          case 7:
            checkEncCryptoKey(privateKey, 'ECDH', 'deriveBits');
            value = concat(lengthAndInput(encoder.encode(algorithm)), lengthAndInput(apu), lengthAndInput(apv), uint32be(keyLength));

            if (publicKey.algorithm.name === 'X25519') {
              length = 256;
            } else if (publicKey.algorithm.name === 'X448') {
              length = 448;
            } else {
              length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
            }

            _context.t0 = Uint8Array;
            _context.next = 13;
            return crypto.subtle.deriveBits({
              name: publicKey.algorithm.name,
              public: publicKey
            }, privateKey, length);

          case 13:
            _context.t1 = _context.sent;
            sharedSecret = new _context.t0(_context.t1);
            return _context.abrupt("return", concatKdf(sharedSecret, keyLength, value));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _deriveKey.apply(this, arguments);
}

export function generateEpk(_x5) {
  return _generateEpk.apply(this, arguments);
}

function _generateEpk() {
  _generateEpk = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(key) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (isCryptoKey(key)) {
              _context2.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));

          case 2:
            return _context2.abrupt("return", crypto.subtle.generateKey(key.algorithm, true, ['deriveBits']));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _generateEpk.apply(this, arguments);
}

export function ecdhAllowed(key) {
  if (!isCryptoKey(key)) {
    throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));
  }

  return ['P-256', 'P-384', 'P-521'].includes(key.algorithm.namedCurve) || key.algorithm.name === 'X25519' || key.algorithm.name === 'X448';
}